import api from './api';
import { VoicemailResponse } from '../types/voicemail.types';
import config from '../config';

class VoicemailService {
  async getVoicemails(): Promise<VoicemailResponse> {
    const response = await api.get<VoicemailResponse>('/endpoints/voicemail');
    return response.data;
  }

  async getUnreadCount(): Promise<number> {
    try {
      const response = await api.get<VoicemailResponse>('/endpoints/voicemail');
      if (response.data.success && response.data.data.voicemails) {
        return response.data.data.voicemails.filter(vm => !vm.is_read).length;
      }
      return 0;
    } catch (error) {
      console.error('Error fetching unread count:', error);
      return 0;
    }
  }

  async markAsRead(id: number, isRead: boolean): Promise<void> {
    await api.post('/endpoints/voicemail_mark', {
      id,
      is_read: isRead
    });
  }

  async deleteVoicemail(id: number): Promise<void> {
    await api.delete('/endpoints/voicemail', {
      data: { id }
    });
  }

  getAudioUrl(id: number): string {
    return `${config.apiUrl}/endpoints/voicemail_audio?id=${id}`;
  }
}

const voicemailService = new VoicemailService();
export default voicemailService;